import React from 'react';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClientContactInfoTable from './ClientContactInfoTable';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  popper: {
    zIndex: '9 !important',
  },
}));

export default function ClientAccordion({title, children}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <div className={classes.root}>
        <Accordion
          className="accordion-styling"
          elevation={0}
          expanded={expanded}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className={classes.heading}>Client Contact Information </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.detailsCard}>
            <ClientContactInfoTable />
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
